export const startedCompanyId = 'WA241000'